export const accountUserDetailKey = ['account', 'user', 'detail'];
export const USER_DETAIL_QUERY_KEYS = {
  ALL: ['account', 'user', 'detail'],
  USER_INFO: ['account', 'user', 'detail', 'userInfo'],
  USER_INFO_V2: ['account', 'user', 'detail', 'userInfoV2'],
  USER_INFO_EDIT: ['account', 'user', 'detail', 'userInfo', 'edit'],
  MIGRATION: ['account', 'user', 'detail', 'userInfo', 'migrate'],
};
